var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.stateType === 'Low')?_c('LowStateTypeDashboard'):_vm._e(),(_vm.stateType === 'Medium')?_c('MediumStateTypeDashboard'):_vm._e(),(_vm.stateType === 'High')?_c('HighStateTypeDashboard'):_vm._e(),_c('VersionModal',{ref:"showVersionModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }